module.exports = __webpack_public_path__ + "media/Mobile_Mock_Sustain_Home.7683b7c8.mp4";